<script>
import QuantityControl from "@/components/QuantityControl.vue"
import TruncatedText from "@/components/TruncatedText.vue"

export default {


  components:{QuantityControl, TruncatedText},

  name: "CartItem",
  props: {
    item: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    isQuoteMenu: { type: Boolean, default: false },
  },
  data() {
    return {
      localNote: this.item.note || "",
      showNoteByItemId: null,
      displayTrash: false,
    };
  },


  methods: {

    removeItem() {
      if(this.disabled){
        return
      }
        this.$store.dispatch("cart/removeFromOrder", this.item.orderLineId);
    },

    handlerDisplayTrash(displayTrash){
      this.displayTrash = displayTrash
    },

    saveNote(item){
      this.$store.dispatch("cart/addNoteToOrderLine", { orderLineId: item.orderLineId, note:this.localNote })  
      .then(() =>{
        this.showNoteByItemId = null;
      })
    },

   noteFieldIsVisible(item){
      return item.id == this.showNoteByItemId
   },

   showNoteField(item) {
      this.showNoteByItemId = this.showNoteByItemId == null ? item.id : null ;
    },

    cancelChangeNote(item){
      this.localNote = item.note;
      this.showNoteField(item)
    },

    getImageUrl(id) {
      return `/api/image/get/menu/id/${id}`;
    },
  },

};
</script>

<template>
  <li class="media mb-3 pl-3 pr-3 pb-2 pt-2 align-items-center">
    <div class="mr-3 image-wrapper">
    <img 
      :src="getImageUrl(item.id)"
      alt="item"
      class="main-image"
    />
    <img
      @click="removeItem"
      v-if="isQuoteMenu && displayTrash"
      alt="trash"
      src="@/assets/icons/trash.svg"
      class="trash-icon"
    />
  </div>


    <div class="media-body">
      <div class="d-flex justify-content-between align-items-center">
        <div >
          <div class="font-size-14 text-dark font-weight-bold"> {{ item.name }} </div>
          <div class="mt-1 font-size-12 text-dark">{{ item.cartItemSubTotal }}</div>
        </div>
        <QuantityControl
          :item="item"
          :quantity="item.cartItemQuantity"
          :iconSize="15"
          :fontSize="16"
          :btnSize="30"
          :disabled="disabled"
          :manualInput="isQuoteMenu"
          @displayTrash="handlerDisplayTrash"
        />
      </div>

      

      <b-form-textarea
        v-if="noteFieldIsVisible(item)"
        v-model="localNote"
        placeholder="Ajouter une note..."
        rows="1"
        class="mt-2"
      >
      </b-form-textarea>

      <div class="mt-2" v-if="!noteFieldIsVisible(item)" >
          <TruncatedText
            :text="localNote ? localNote : (item && item.submissionDate) ? '' : $t('menuOrder.cart.showNote')"
            :showMoreLabel="$t('menuOrder.cart.showMore')"
            :showLessLabel="$t('menuOrder.cart.showLess')"
            :disabled="item && item.submissionDate ? true : false"
            @onClick="showNoteField(item)"
          />

      </div>

      <div v-else class="mr-2" >
        <span>
          <img alt="send" height="14"  src="@/assets/icons/send-hor.svg"  class="" @click="showNoteField(item)"/>
          <small class="text-dark text-uppercase font-weight-bold" @click="saveNote(item)">{{ $t('menuOrder.cart.button.save') }}</small> 
        </span>

        <span class="ml-2" @click="cancelChangeNote(item);">
          <img alt="send" height="14"  src="@/assets/icons/close-danger.svg" />
          <small class="text-danger text-uppercase font-weight-bold">{{ $t('menuOrder.cart.button.cancel') }}</small> 
        </span>
      </div>

      
    </div>
  </li>
</template>


<style scoped>
.image-wrapper {
  position: relative;
  width: 60px;
  height: 60px;
}

.main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.trash-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 25px;
  height: 25px;
  transform: translate(-50%, -50%);
  cursor: pointer;

  background: rgba(255, 255, 255, 0.6);
  padding: 6px;
  border-radius: 50%;
  backdrop-filter: blur(4px);
}

.quantity-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
</style>
